const X = 10.7639104167
const Y = 3.281

export const SQM = 'sqm'
export const SQFT = 'sqft'

export const metric = (units: string) => units === SQM
export const toSqm = (sqft: number) => sqft / X
export const toSqft = (sqm: number) => sqm * X
export const toMeters = (ft: number) => ft / Y
